import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn helper: merges Tailwind classes intelligently
 * (handles conflicting classes like `p-4 p-2` → `p-2`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format price in tiyin → "12 500 000 сум"
 */
export function formatPrice(tiyin: number, currency: string = "сум"): string {
  const sums = Math.floor(tiyin / 100);
  const formatted = sums.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${formatted} ${currency}`;
}

/**
 * Format date in Asia/Tashkent timezone (DD.MM.YYYY HH:MM)
 */
export function formatDate(iso: string | Date): string {
  const date = typeof iso === "string" ? new Date(iso) : iso;
  return new Intl.DateTimeFormat("ru-RU", {
    timeZone: "Asia/Tashkent",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
